import * as types from "../mutationTypes";
import auth from '../../utils/auth'

export const alertSuccess = ({ commit }, message) => {
  commit(types.SET_ALERT, {
    isVisible: true,
    typeClass: "success",
    message: message,
  });
}

export const alertDanger = ({ commit }, message) => {
    commit(types.SET_ALERT, {
      isVisible: true,
      typeClass: "danger",
      message: message,
    });
  }
  export const closeAlert = ({ commit }) => {
    commit(types.SET_ALERT, {
        isVisible: false,
        typeClass: "secondary",
        message: '',
    })
}

export const setGetData = ({commit}, visibility) => {
  // commit(types.SET_VISIBILITY_GET_DATA, visibility)
}

export const setVisibilityVisitantForm = ({state}, value) => {
  state.visitant_form.isVisible = auth.loggedIn
}

